module.exports = __webpack_public_path__ + "img/8.1.d70fee79.jpg";